import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
  Divider,
  Grid,
  TextField,
  Autocomplete,
  Button,
  Stack,
} from '@mui/material';
import { Add } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import CustomSnackbar from '../../../components/CustomSnackbar';
// Ensure you have this component or replace with your Snackbar impl


const ProductForm = ({
  formKey,
  initialValues,
  pageTitle,
  closePopup,

  formState,
  handleChange,
  handleProductSubmit,

  // selects - values
  selectedProductgroup,
  selectedProductsubgroup,
  selectedvariety,
  selectedgrade,
  selectedhsn,
  selectedgrain,
  selectedUnit,
  selectedcoreid,
  selectedDiscountType,
  selectedOrderType,
  selectedPackageType,
  selectedremarks,

  // selects - handlers
  handleSelectProductgroup,
  handleSelectProductsubgroup,
  handleSelectvariety,
  handleSelectgrade,
  handleSelecthsn,
  handleSelectgrain,
  handleSelectUnit,
  handleSelectcoreid,
  handleSelectDiscountType,
  handleSelectOrderType,
  handleSelectPackageType,
  handleSelectremarks,

  // options
  dataProductgroup,
  optionsProductSubgroup,
  optionsVariety,
  dataGrade,
  dataHsn,
  datagrain,
  dataUnit,
  dataCoreID,
  dataDiscountType,
  dataOrderType,
  dataPackageType,
  dataRemarks,

  // errors
  ProductGroupError,
  ProductSubGroupError,
  ProductVarietyError,
  GradeError,
  HSNError,
  GSMError,
  WidthError,
  ReelODError,
  CoreIDError,
  NoOfSheetsError,
  RequiredQtyError,
  COQtyError,
  UnitpriceError,
  BillingRateError,
  PackageTypeError,

  // flags
  disabledCoreID,
  disabledNoofSheets,
  disabledReelOD,

  // snackbar
  snackbarOpen,
  alertMessage,
  alertsevierity,
  handleSnackbarClose,
}) => {


  //   // Local state per mount; key on parent forces remount to clear stale values
  //   const [values, setValues] = useState(initialValues);

  //   // In case parent updates props late within same mount
  //   useEffect(() => {
  //   if (formKey === 'new') {
  //     setValues(initialValues);
  //   } else {
  //     setValues(formState);
  //   }
  // }, [formKey, initialValues]);

  return (
    <Box component="form" autoComplete="off" sx={{ width: '100%' }}>
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h3" fontSize={20} ml={1} fontWeight="500">
          {pageTitle}
        </Typography>
        <Tooltip title="Close">
          <IconButton onClick={closePopup}>
            <CloseIcon sx={{ color: '#e57373' }} />
          </IconButton>
        </Tooltip>
      </Box>

      <Divider sx={{ mt: '2px', mb: '2px', height: '0.2px' }} />

      <Grid container spacing={0}>
        {/* First Column */}
        <Grid item xs={12} md={6} sx={{ mr: { md: 2 } }}>
          {/* Group */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '5px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Group <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8}>
              <Autocomplete
                size="small"
                value={selectedProductgroup || null}
                onChange={handleSelectProductgroup}
                options={dataProductgroup}
                getOptionLabel={(option) => option?.Description || ''}
                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Group"
                    variant="outlined"
                    required
                    error={!!(ProductGroupError && ProductGroupError.length)}
                    helperText={ProductGroupError}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Sub Group */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Sub Group <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8}>
              <Autocomplete
                id="dropdown_product_subgroup"
                size="small"
                value={selectedProductsubgroup || null}
                onChange={handleSelectProductsubgroup}
                options={optionsProductSubgroup}
                getOptionLabel={(option) => option?.Description || ''}
                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Sub Group"
                    variant="outlined"
                    required
                    error={!!(ProductSubGroupError && ProductSubGroupError.length)}
                    helperText={ProductSubGroupError}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Variety */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Variety <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8}>
              <Autocomplete
                id="dropdown_variety"
                size="small"
                value={selectedvariety || null}
                onChange={handleSelectvariety}
                options={optionsVariety}
                getOptionLabel={(option) => option?.Description || ''}
                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Variety"
                    variant="outlined"
                    required
                    error={!!(ProductVarietyError && ProductVarietyError.length)}
                    helperText={ProductVarietyError}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Grade */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Grade <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8}>
              <Autocomplete
                id="dropdown_grade"
                size="small"
                value={selectedgrade || null}
                onChange={handleSelectgrade}
                options={dataGrade}
                getOptionLabel={(option) => option?.Description || ''}
                isOptionEqualToValue={(option, value) => option.CodeId === value.CodeId}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grade"
                    variant="outlined"
                    required
                    error={!!(GradeError && GradeError.length)}
                    helperText={GradeError}
                  />
                )}
              />
            </Grid>
          </Grid>
          {/* HSN Code */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                HSN Code <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={10} sm={8}>
              <Autocomplete
                id="dropdown_hsncode"
                size="small"
                value={selectedhsn || null}
                onChange={handleSelecthsn}
                options={dataHsn}
                getOptionLabel={(option) => option?.hsncode?.toString() || ""}
                isOptionEqualToValue={(option, value) => option.hsncode === value.hsncode}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="HSN"
                    variant="outlined"
                    required
                    error={!!(HSNError && HSNError.length)}
                    helperText={HSNError}
                  />
                )}
              />

            </Grid>
          </Grid>

          {/* GSM */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                GSM <Typography component="span" sx={{ color: '#FF5349' }}>*</Typography>
              </Typography>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                label="GSM"
                type="number"
                name="GSM"
                value={formState?.GSM ?? ''}
                onChange={handleChange}
                error={!!(GSMError && GSMError.length)}
                helperText={GSMError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
          </Grid>

          {/* BF */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">BF</Typography>
            </Grid>
            <Grid item xs={3}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                label="BF"
                type="number"
                name="BF"
                value={formState?.BF ?? 0}
                onChange={handleChange}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
              />
            </Grid>
          </Grid>

          {/* Size */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Size (Width <span style={{ color: '#FF5349', fontSize: 12 }}>*</span>)
              </Typography>
            </Grid>
            <Grid item xs={2.5}>
              <TextField
                size="small"
                fullWidth
                type="number"
                variant="outlined"
                label="Width"
                name="WIDTH"
                value={formState?.WIDTH ?? ''}
                onChange={handleChange}
                error={!!(WidthError && WidthError.length)}
                helperText={WidthError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
            <Grid item xs={0.5}>
              <Typography variant="h6">X</Typography>
            </Grid>
            <Grid item xs={2.5}>
              <TextField
                size="small"
                fullWidth
                type="number"
                variant="outlined"
                label="Length"
                name="LENGTH"
                value={formState?.LENGTH ?? ''}
                onChange={handleChange}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
              />
            </Grid>
            <Grid item xs={2.5}>
              <Autocomplete
                id="dropdown_grain"
                size="small"
                value={selectedgrain}
                onChange={handleSelectgrain}
                options={datagrain}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => <TextField {...params} label="Grain" variant="outlined" />}
              />
            </Grid>
          </Grid>

          {/* UNIT */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Unit</Typography>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                id="dropdown_Unit"
                size="small"
                value={selectedUnit}
                onChange={handleSelectUnit}
                options={dataUnit}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => <TextField {...params} label="Unit" variant="outlined" />}
              />
            </Grid>
          </Grid>

          {/* Reel OD */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Reel OD</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Reel OD (cm)"
                type="number"
                name="REELOD"
                value={formState?.REELOD ?? ''}
                onChange={handleChange}
                disabled={!!disabledReelOD}
                error={!!(ReelODError && ReelODError.length)}
                helperText={ReelODError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
          </Grid>

          {/* Core OD */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Core OD</Typography>
            </Grid>
            <Grid item xs={4}>
              <Autocomplete
                id="dropdown_coreid"
                size="small"
                value={selectedcoreid}
                onChange={handleSelectcoreid}
                options={dataCoreID}
                disabled={!!disabledCoreID}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Core ID (inches)"
                    variant="outlined"
                    required
                    error={!!(CoreIDError && CoreIDError.length)}
                    helperText={CoreIDError}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* No of Sheets */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">No of Sheets</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="No of Sheets"
                type="number"
                name="NOOFSHEETS"
                value={formState?.NOOFSHEETS ?? ''}
                onChange={handleChange}
                //disabled={!!disabledNoofSheets}
                disabled={formState?.LENGTH === 0 || formState?.LENGTH === '' || formState?.LENGTH == null}
                error={!!(NoOfSheetsError && NoOfSheetsError.length)}
                helperText={NoOfSheetsError}
                inputProps={{ style: { textAlign: 'right' } }}
                required
              />
            </Grid>
          </Grid>
        </Grid>



        {/* Second Column */}
        <Grid item xs={12} md={5.7}>
          {/* Number of Reels */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Number of Reels
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Number of Reels "
                type="number"
                name="NOOFREELS"
                value={formState?.NOOFREELS ?? ''}
                onChange={handleChange}
                 disabled={!!(formState?.LENGTH > 0)} 
                // error={!!(RequiredQtyError && RequiredQtyError.length)}
                // helperText={RequiredQtyError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
              />
            </Grid>
          </Grid>
          {/* Order Qty */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Order Qty <span style={{ color: '#FF5349', fontSize: 12 }}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Order Quantity (Kg)"
                type="number"
                name="RequestedQty"
                value={formState?.RequestedQty ?? ''}
                onChange={handleChange}
                error={!!(RequiredQtyError && RequiredQtyError.length)}
                helperText={RequiredQtyError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
          </Grid>

          {/* CO Qty */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                CO Qty <span style={{ color: '#FF5349', fontSize: 12 }}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="CO Quantity (Kg)"
                type="number"
                name="COQTY"
                value={formState?.COQTY ?? ''}
                onChange={handleChange}
                error={!!(COQtyError && COQtyError.length)}
                helperText={COQtyError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
          </Grid>

          {/* Unit Price */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">
                Unit Price <span style={{ color: '#FF5349', fontSize: 12 }}>*</span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Unit Price"
                type="number"
                name="UNITPRICE"
                value={formState?.UNITPRICE ?? ''}
                onChange={handleChange}
                error={!!(UnitpriceError && UnitpriceError.length)}
                helperText={UnitpriceError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Billing Rate"
                type="number"
                name="BILLINGRATE"
                value={formState?.BILLINGRATE ?? ''}
                onChange={handleChange}
                error={!!(BillingRateError && BillingRateError.length)}
                helperText={BillingRateError}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
                required
              />
            </Grid>
          </Grid>

          {/* Discount */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Discount</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <Autocomplete
                id="dropdown_discountType"
                size="small"
                value={selectedDiscountType}
                onChange={handleSelectDiscountType}
                options={dataDiscountType}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => <TextField {...params} label="Discount Type" variant="outlined" />}
              />
            </Grid>
            <Grid item xs={3.5}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Discount/Unit"
                type="number"
                name="DiscountRate"
                value={formState?.DiscountRate ?? ''}
                onChange={handleChange}
                inputProps={{
                  min: 0, // 🚫 prevents negative numbers
                  style: { textAlign: 'right' }
                }}
              />
            </Grid>
          </Grid>

          {/* Order Type */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Order Type</Typography>
            </Grid>
            <Grid item xs={8}>
              <Autocomplete
                id="dropdown_ordertype"
                size="small"
                value={selectedOrderType}
                onChange={handleSelectOrderType}
                options={dataOrderType}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => <TextField {...params} label="Order Type" variant="outlined" />}
              />
            </Grid>
          </Grid>

          {/* Package Type */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Package Type</Typography>
            </Grid>
            <Grid item xs={8}>
              <Autocomplete
                id="dropdown_packageType"
                size="small"
                value={selectedPackageType}
                onChange={handleSelectPackageType}
                options={dataPackageType}
                getOptionLabel={(option) => option?.Description || ''}
                error={!!(PackageTypeError && PackageTypeError.length)}
                helperText={PackageTypeError}
                renderInput={(params) => <TextField {...params} label="Package Type" variant="outlined" />}
              />
            </Grid>
          </Grid>

          {/* Remarks */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Remarks</Typography>
            </Grid>
            <Grid item xs={8}>
              {/* <Autocomplete
                id="dropdown_remarks"
                size="small"
                value={selectedremarks}
                onChange={handleSelectremarks}
                options={dataRemarks}
                getOptionLabel={(option) => option?.Description || ''}
                renderInput={(params) => <TextField {...params} label="Remarks" variant="outlined" />}
              /> */}

              {/* <Autocomplete
                freeSolo
                 id="dropdown_remarks"
                value={selectedremarks}
                size="small"
                options={dataRemarks}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option?.Description || ""
                }
                onChange={(event, newValue) => {
                  // normalize before sending up
                  if (typeof newValue === "string") {
                    handleSelectremarks({ Description: newValue });
                  } else if (newValue) {
                    handleSelectremarks(newValue);
                  } else {
                    handleSelectremarks(null);
                  }
                }}
                renderInput={(params) => <TextField {...params} label="Remarks"  variant="outlined"  />}
              /> */}

              <Autocomplete
                freeSolo
                size="small"
                value={selectedremarks}
                options={dataRemarks}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option?.Description || ""
                }
                onChange={(event, newValue) => {
                  // ✅ Called when selecting or pressing Enter
                  if (typeof newValue === "string") {
                    handleSelectremarks({ Description: newValue });
                  } else if (newValue) {
                    handleSelectremarks(newValue);
                  } else {
                    handleSelectremarks(null);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Remarks"
                    variant="outlined"
                    onBlur={(e) => {
                      // ✅ Called when leaving the field (click outside / choose another component)
                      const typedValue = e.target.value;
                      if (typedValue) {
                        handleSelectremarks({ Description: typedValue });
                      }
                    }}
                  />
                )}
              />




            </Grid>
          </Grid>

          {/* Special Instructions */}
          <Grid container spacing={1} sx={{ ml: 0, mt: '1px' }}>
            <Grid item xs={2} sm={3}>
              <Typography variant="h6">Special Instr.</Typography>
            </Grid>
            <Grid item xs={8}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Special Instructions"
                name="SPECIAL_INSTRUCTION"
                value={formState?.SPECIAL_INSTRUCTION ?? ''}
                onChange={handleChange}
                multiline
                rows={2}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Divider sx={{ mt: '10px', height: '0.2px' }} />

      <Box sx={{ mt: '10px', mr: '5px', display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          sx={{ textTransform: 'none' }}
          startIcon={<Add />}
          onClick={handleProductSubmit}
          type="submit"
        >
          {pageTitle === 'Add Product Detail' ? 'Add Product' : 'Update Product'}
        </Button>
      </Box>

      <Stack>
        <CustomSnackbar
          open={!!snackbarOpen}
          message={alertMessage}
          onClose={handleSnackbarClose}
          type={alertsevierity}
        />
      </Stack>
    </Box>
  );
};

export default ProductForm;

